/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net Command API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  SchemaValidationErrorResponse,
  StandardError,
  Vehicle,
  VehicleInput,
  Vehicles,
  VehiclesParams
} from '../../models';

import { axiosClient } from '../../../axiosAdminClient.ts';
import type { ErrorType } from '../../../axiosAdminClient.ts';




/**
 * @summary Vehicles list
 */
export const vehicles = (
    params?: MaybeRefOrGetter<VehiclesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Vehicles>(
      {url: `/vehicles`, method: 'GET',
        params, signal
    },
      );
    }




export const getVehiclesQueryKey = (params?: MaybeRefOrGetter<VehiclesParams>,) => {
    return [
    'vehicles', ...(params ? [params] : [])
    ] as const;
    }


export const getVehiclesQueryOptions = <TData = Awaited<ReturnType<typeof vehicles>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<VehiclesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vehicles>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getVehiclesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vehicles>>> = ({ signal }) => vehicles(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vehicles>>, TError, TData>
}

export type VehiclesQueryResult = NonNullable<Awaited<ReturnType<typeof vehicles>>>
export type VehiclesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Vehicles list
 */

export function useVehicles<TData = Awaited<ReturnType<typeof vehicles>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<VehiclesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vehicles>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVehiclesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Destroy Vehicle
 */
export const destroyVehicle = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Vehicle>(
      {url: `/vehicles/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyVehicleMutationKey = () => ['destroyVehicle'] as const;

export const getDestroyVehicleMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyVehicle>>, TError,DestroyVehicleMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyVehicle>>, TError,DestroyVehicleMutationVariables, TContext> => {

const mutationKey = getDestroyVehicleMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyVehicle>>, DestroyVehicleMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyVehicle(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyVehicleMutationResult = NonNullable<Awaited<ReturnType<typeof destroyVehicle>>>

    export type DestroyVehicleMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyVehicleMutationVariables = {id: string}

    /**
 * @summary Destroy Vehicle
 */
export const useDestroyVehicle = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyVehicle>>, TError,DestroyVehicleMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyVehicle>>,
        TError,
        DestroyVehicleMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyVehicleMutationOptions(options), queryClient);
    }
    /**
 * @summary Vehicle Detail
 */
export const vehicle = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<Vehicle>(
      {url: `/vehicles/${id}`, method: 'GET', signal
    },
      );
    }




export const getVehicleQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'vehicles',id
    ] as const;
    }


export const getVehicleQueryOptions = <TData = Awaited<ReturnType<typeof vehicle>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vehicle>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getVehicleQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof vehicle>>> = ({ signal }) => vehicle(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof vehicle>>, TError, TData>
}

export type VehicleQueryResult = NonNullable<Awaited<ReturnType<typeof vehicle>>>
export type VehicleQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Vehicle Detail
 */

export function useVehicle<TData = Awaited<ReturnType<typeof vehicle>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof vehicle>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getVehicleQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Vehicle
 */
export const updateVehicle = (
    id: MaybeRefOrGetter<string>,
    vehicleInput: MaybeRefOrGetter<VehicleInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
vehicleInput = toValue(vehicleInput);

      return axiosClient<Vehicle>(
      {url: `/vehicles/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: vehicleInput, signal
    },
      );
    }




export const getUpdateVehicleMutationKey = () => ['updateVehicle'] as const;

export const getUpdateVehicleMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVehicle>>, TError,UpdateVehicleMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateVehicle>>, TError,UpdateVehicleMutationVariables, TContext> => {

const mutationKey = getUpdateVehicleMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateVehicle>>, UpdateVehicleMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateVehicle(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateVehicleMutationResult = NonNullable<Awaited<ReturnType<typeof updateVehicle>>>
    export type UpdateVehicleMutationBody = VehicleInput
    export type UpdateVehicleMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateVehicleMutationVariables = {id: string;data: VehicleInput}

    /**
 * @summary Update Vehicle
 */
export const useUpdateVehicle = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateVehicle>>, TError,UpdateVehicleMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateVehicle>>,
        TError,
        UpdateVehicleMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateVehicleMutationOptions(options), queryClient);
    }
